import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { parse } from 'qs'
import { Route } from 'react-router-dom'

import * as actions from 'redux/actions'
import * as routes from 'routes'

import Main from './Main'
import ResetPassword from './ResetPassword'

class Home extends Component {
  constructor (props) {
    super(props)

    this.onSignIn = this.onSignIn.bind(this)
    this.onSignUp = this.onSignUp.bind(this)
    this.onResetPassword = this.onResetPassword.bind(this)
  }

  async componentWillMount () {
    const { location, history, verifyUser } = this.props
    if (location.search) {
      const query = parse(location.search.substr(1))

      if (query.e && query.t) {
        switch (location.pathname) {
          case routes.verify():
            await verifyUser(query.e, query.t)
            history.push(routes.emailVerified())
            break
          case routes.reset():
            break
          default:
            history.push(routes.home())
        }
      }
    }
  }

  async onSignIn (data) {
    const { signIn } = this.props
    const response = await signIn(data.email, data.password, data.captcha)

    this._recaptchaSignIn.reset()

    if (response.errors) {
      throw new SubmissionError(response.errors)
    }

    return response
  }

  async onSignUp (data) {
    const { history, signUp } = this.props
    const response = await signUp(data)

    this._recaptchaSignUp.reset()

    if (response.errors) {
      throw new SubmissionError(response.errors)
    }

    history.push(routes.signIn())
  }

  async onResetPassword (data) {
    const { history, resetPassword, location } = this.props

    const query = parse(location.search.substr(1))

    const response = await resetPassword(query.e, query.t, data.newPassword)

    if (response.errors) {
      throw new SubmissionError(response.errors)
    }

    history.push(routes.signIn())
  }

  render () {
    return (
      <div>
        <Route path={routes.reset()} render={() => (
          <ResetPassword visible onSubmit={this.onResetPassword} />
        )} />
        <Main
          onSignIn={this.onSignIn}
          onSignUp={this.onSignUp}
          recaptchaSignInRef={e => { this._recaptchaSignIn = e }}
          recaptchaSignUpRef={e => { this._recaptchaSignUp = e }}
        />
      </div>
    )
  }
}

Home.propTypes = {
  signIn: PropTypes.func.isRequired
}

export default connect(null, actions)(Home)



// WEBPACK FOOTER //
// ./src/containers/Home/index.js